import { Box, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

interface GroupsSearchFieldProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

/**
 * Pole wyszukiwania grup
 * Zgodny z wzorcem ParticipantsSearchField - spójność wizualna
 */
export default function GroupsSearchField({
  searchTerm,
  onSearchChange,
}: GroupsSearchFieldProps) {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderBottom: "1px solid #ddd",
        px: { xs: 2, sm: 3 },
        py: 2,
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Wyszukaj po nazwie grupy lub zawodnikach w grupie..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: "#6366f1", fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ddd",
            },
            "&:hover fieldset": {
              borderColor: "#6366f1",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#6366f1",
            },
          },
        }}
      />
    </Box>
  );
}

